import request from '@/utils/request'

//用户注册
export function registerUser(data) {
    return request({
      url: '/Teacher/registerUser.do',
      method: 'post',
      data:data
    })
}

//用户登录
export function userLogin(data) {
  return request({
    url: '/Teacher/userLogin.do',
    method: 'post',
    data:data
  })
}

//获取用户
export function getTrueUser(data) {
  return request({
    url: '/Teacher/getTrueUser.do',
    method: 'post',
    data:data
  })
}

//上传用户头像
export function uploadUserPhoto(data) {
  return request({
    url: '/Teacher/uploadUserPhoto.do',
    method: 'post',
    data:data
  })
}

//保存用户信息
export function userEdit(data) {
  return request({
    url: '/Teacher/userEdit.do',
    method: 'post',
    data:data
  })
}

//保存用户信息
export function wxtoLoginAPI(data) {
  return request({
    url: '/Teacher/wxtoLogin.do',
    method: 'get',
    params:data
  })
}